
const trackMetaEvent = (eventName, parameters = {}) => {
  if (typeof window.fbq === "function") {
    window.fbq("track", eventName, parameters);
  }
};

// Phone, WhatsApp, or email link click
export const trackMetaContact = (method) => {
  trackMetaEvent("Contact", {
    contact_method: method,
  });
};

// Successful enquiry submission
export const trackMetaLead = () => {
  trackMetaEvent("Lead");
};

// Service detail page viewed
export const trackMetaViewContent = (serviceName) => {
  trackMetaEvent("ViewContent", {
    content_name: serviceName,
    content_category: "IT Services",
  });
};
